import axios from 'axios';
import VuexCache from 'vuex-cache';

// state management -- switch this out for real app API and persistence
var apiBase = "./data/";

const storeConfig = {
  state: {
    posts: [],
    faq: [],
    messages: [],
    chartData: [],
    tasks: []
  },
  plugins:[VuexCache],
  actions: {
    LOAD_POSTS: function ({ commit }) {
      axios.get(apiBase+'posts.json')
      .then(response => {
        commit('SET_POSTS', { list: response.data })
      })
      .catch(e => {
        console.log(e);
      })
    },
    ADD_NEW_POST: function ({ commit }) {
      axios.post(apiBase+'posts.json').then((response) => {
        commit('ADD_POST', { item: response.data })
      }, (e) => {
        console.log(e)
      })
    },
    LOAD_FAQ: function ({ commit }) {
      axios.get(apiBase+'faq.json')
      .then(response => {
        commit('SET_FAQ', { list: response.data })
      })
      .catch(e => {
        console.log(e);
      })
    },
    LOAD_MESSAGES: function ({ commit }) {
      axios.get(apiBase+'messages.json')
      .then(response => {
        commit('SET_MESSAGES', { list: response.data })
      })
      .catch(e => {
        console.log(e);
      })
    },
    LOAD_CHART_DATA: function ({ commit }) {
      axios.get(apiBase+'chart_bar.json')
      .then(response => {
        commit('SET_CHART_DATA', { obj: response.data })
      })
      .catch(e => {
        console.log(e);
      })
    },
    LOAD_TASKS: function ({ commit }) {
      axios.get(apiBase+'tasks.json')
      .then(response => {
        commit('SET_TASKS', { list: response.data })
      })
      .catch(e => {
        console.log(e);
      })
    }
  },
  mutations: {
    SET_POSTS: (state, { list }) => {
      state.posts = list
    },
    ADD_POST: (state, { item }) => {
      state.posts.push(item)
    },
    SET_FAQ: (state, { list }) => {
      state.faq = list
    },
    SET_MESSAGES: (state, { list }) => {
      state.messages = list
    },
    SET_TASKS: (state, { list }) => {
      state.tasks = list
    },
    SET_CHART_DATA: (state, { obj }) => {
      state.chartData = obj
    }
  },
  getters: {
    getPostsAlpha: state => {
      return state.posts.sort((a, b) => a.title > b.title)
    },
    getPostById: state => (id) => {
      return state.posts.find(item => item.id == id)
    },
    getChartByIndex: state => (idx) => {
      return state.chartData[idx]
    },
    getChartByKey: state => (key) => {
      return state.chartData[key]
    },
    getTasksTop: state => (howMany) => {
      return state.tasks.slice(0,howMany)
    }
  }
}

export default storeConfig
